import React from "react";
import { LegalPage, LegalBlock } from "@/components/site/LegalPage";

export default function MentionsLegales() {
  return (
    <LegalPage title="Mentions légales" path="/mentions-legales">
      <LegalBlock heading="Éditeur du site">
        <p>Ninaa Beauty — institut de beauté et bien-être.</p>
        <p>Responsable de la publication : Ninaa Beauty</p>
        <p>Statut / forme juridique : Entreprise individuelle (micro-entreprise)</p>
        <p>Adresse : 31 rue du Rempart Matabiau, 31000 Toulouse</p>
        <p>SIRET : 983 791 609 00016</p>
        <p>Email : ninaa.beaauty@gmail.com</p>
        <p>Téléphone : 07 44 97 22 82</p>
      </LegalBlock>

      <LegalBlock heading="Hébergement">
        <p>
          Ce site est hébergé par IONOS SARL, 7 place de la Gare, BP 70109,
          57201 Sarreguemines Cedex, France — Tél. : 0970 808 911.
        </p>
      </LegalBlock>

      <LegalBlock heading="Propriété intellectuelle">
        <p>
          L’ensemble des contenus présents sur ce site (textes, photographies,
          illustrations, logo) est la propriété de Ninaa Beauty, sauf mention
          contraire. Toute reproduction, même partielle, est interdite sans
          autorisation préalable.
        </p>
      </LegalBlock>

      <LegalBlock heading="Réservations">
        <p>
          Les réservations en ligne sont gérées via la plateforme Planity. Les
          conditions applicables sont celles de ce prestataire.
        </p>
      </LegalBlock>
    </LegalPage>
  );
}
